// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + (chunkId === 347 ? "secondary" : chunkId) + "." + {"173":"f94bec3b83891e475fd2","347":"4e2504efb386ad3917c8","754":"86cb443ebf2fa6877303"}[chunkId] + ".js";
};